<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ScrollView extends Vue {
  @Prop({ type: String, default: 'div' }) tag!: string;
  mounted() {
    let i: any;
    const scrollEle = this.$refs.scrollContainer;
    if (scrollEle) {
      this.scrollFix(scrollEle);
    }
  }
  scrollFix(elem: HTMLElement) {
    const handle = function (event: TouchEvent) {
      let startTopScroll;
      const startY = event.touches[0] && event.touches[0].pageY;
      if (startY) {
        startTopScroll = elem.scrollTop;
        // 当滚动条在最顶部的时候
        if (startTopScroll <= 0) elem.scrollTop = 1;
        // 当滚动条在最底部的时候
        if (startTopScroll + elem.offsetHeight >= elem.scrollHeight)
          elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1;
      }
    };
    elem.addEventListener('touchstart', handle, false);
    this.beforeDestroy = () => {
      elem.removeEventListener('touchstart', handle, false);
    };
    return handle;
  }
  render(h: any) {
    const tag = this.$props.tag;

    return h(
      tag,
      {
        ref: 'scrollContainer',
        class: 'scroll-view',
      },
      this.$slots.default
    );
  }
}
</script>

<style lang="scss" scoped>
.scroll-view {
  overflow-y: scroll;
}
</style>
